import { render, staticRenderFns } from "./Simulator.vue?vue&type=template&id=032b1b02&scoped=true&"
import script from "./Simulator.vue?vue&type=script&lang=js&"
export * from "./Simulator.vue?vue&type=script&lang=js&"
import style0 from "./Simulator.vue?vue&type=style&index=0&id=032b1b02&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "032b1b02",
  null
  
)

export default component.exports